angular.module('permanentUnitModule', ['permanentUnitTemplates', 'LocalStorageModule']);

angular.module('permanentUnitModule').config(['localStorageServiceProvider',function (localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('crApp');
}]);